import { HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { catchError, Observable, tap, throwError } from 'rxjs';

import { ApiLoaderService } from './api-loader.service';

@Injectable({
  providedIn: 'root',
})
export class ApiLoaderInterceptorService {
  private platformId = inject(PLATFORM_ID);

  constructor(
    private loaderService: ApiLoaderService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isPublic = req.headers.get('isPublic') === 'true';
    const hideLoader = req.headers.get('hideLoader') === 'true';
    const existingAccessToken = req.headers.get('x-access-token');
    let token: string | null = null;

    if (isPlatformBrowser(this.platformId)) {
      token = localStorage.getItem('token');
    }

    // Show loader unless explicitly hidden
    if (!hideLoader) {
      this.loaderService.show();
    }

    let modifiedRequest = req;

    // If not public, add Authorization header
    if (!isPublic && token && !existingAccessToken) {
      modifiedRequest = req.clone({
        setHeaders: {
          //   Authorization: `Bearer ${token}`,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'x-access-token': `${token}`,
          observe: 'response',
        },
      });
    }

    return next.handle(modifiedRequest).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse && !hideLoader) {
          this.loaderService.hide();
        }
      }),
      catchError((error) => {
        if (!hideLoader) {
          this.loaderService.hide();
        }
        if (error.status === 401 && isPlatformBrowser(this.platformId)) {
          localStorage.clear();
          this.router.navigateByUrl('auth/login');
        }
        return throwError(() => error);
      })
    );
  }
}
